module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ui modal",
    attrs: {
      "id": "helpModal"
    }
  }, [_c('div', {
    staticClass: "scrolling content"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "ui tab basic segment",
    attrs: {
      "data-tab": "second"
    }
  }, [_c('support-ticket-form', {
    ref: "issueSupportTicketForm",
    attrs: {
      "category": 'issue',
      "label": 'Question / Issue in detail',
      "lastClosedAt": _vm.lastClosedAt
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "ui tab basic segment",
    attrs: {
      "data-tab": "third"
    }
  }, [_c('support-ticket-form', {
    ref: "newFeatureSupportTicketForm",
    attrs: {
      "category": 'new_feature',
      "label": 'Request a new feature',
      "lastClosedAt": _vm.lastClosedAt
    }
  })], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ui secondary pointing menu"
  }, [_c('a', {
    staticClass: "blue item",
    attrs: {
      "data-tab": "first"
    }
  }, [_vm._v("Frequently Asked Questions")]), _vm._v(" "), _c('a', {
    staticClass: "olive active item",
    attrs: {
      "data-tab": "second"
    }
  }, [_vm._v("Contact Us / Report an Issue")]), _vm._v(" "), _c('a', {
    staticClass: "brown item",
    attrs: {
      "data-tab": "third"
    }
  }, [_vm._v("Feature Requests")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ui tab basic segment",
    attrs: {
      "data-tab": "first"
    }
  }, [_c('div', {
    staticClass: "ui accordion"
  }, [_c('h5', [_vm._v("Products")]), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_c('i', {
    staticClass: "dropdown icon"
  }), _vm._v("\n        I have some products I can't see on my dashboard.\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('p', {
    staticClass: "transition hidden"
  }, [_vm._v("\n          By default SentryKit will start to track every ASIN that has had a sale recently. Products with an active offer but no sales will be ignored until the first sale occurs to save you on SentryKit fees. "), _c('br'), _c('br'), _vm._v("\n          You can change all of these in your "), _c('a', {
    attrs: {
      "target": "_blank",
      "href": "/productsettings"
    }
  }, [_vm._v("Product Settings")]), _vm._v("."), _c('br'), _c('br'), _vm._v("\n          (Products with no active offer will be excluded from every list)\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_c('i', {
    staticClass: "dropdown icon"
  }), _vm._v("\n        I have a "), _c('i', [_vm._v("lot")]), _vm._v(" of products, do I have to pick/ignore them one by one?\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('p', {
    staticClass: "transition hidden"
  }, [_vm._v("A bulk edit option is available. Check out the Import/Export section in your "), _c('a', {
    attrs: {
      "target": "_blank",
      "href": "/productsettings"
    }
  }, [_vm._v("Product Settings")]), _vm._v(" at the bottom of the screen.")])]), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_c('i', {
    staticClass: "dropdown icon"
  }), _vm._v("\n        Does SentryKit automatically track my new products?\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('p', {
    staticClass: "transition hidden"
  }, [_vm._v("By default, yes. Both new products and long-time inactive products that started selling again (unless they are on your ignore list). "), _c('br'), _c('br'), _vm._v("\n        You can change this in your "), _c('a', {
    attrs: {
      "target": "_blank",
      "href": "/productsettings"
    }
  }, [_vm._v("Product Settings")]), _vm._v(", look for the section directly above the Save button.")])]), _vm._v(" "), _c('h5', [_vm._v("E-mails")]), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_c('i', {
    staticClass: "dropdown icon"
  }), _vm._v("\n        Help, sooo many e-mails, what to do?!\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('p', {
    staticClass: "transition hidden"
  }, [_vm._v("\n          - "), _c('b', [_vm._v("To change your alert subscriptions:")]), _vm._v(" "), _c('a', {
    attrs: {
      "target": "_blank",
      "href": "/settings"
    }
  }, [_vm._v("Account Settings")]), _vm._v(" -> E-mail -> Manage "), _c('br'), _c('br'), _vm._v("\n          - "), _c('b', [_vm._v("Mute a specific Alert for a Specific ASIN:")]), _vm._v(" Select the \"Issues\" tab on your dashboard. Hover over a product then click the \"Mute...\" dropdown button."), _c('br'), _c('br'), _vm._v("\n          - "), _c('b', [_vm._v("Rewise what ASINs")]), _vm._v(" you would like SentryKit to track in your "), _c('a', {
    attrs: {
      "target": "_blank",
      "href": "/productsettings"
    }
  }, [_vm._v("Product Settings")]), _vm._v(".\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_c('i', {
    staticClass: "dropdown icon"
  }), _vm._v("\n        How can I add a notification e-mail address for a team member?\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('p', {
    staticClass: "transition hidden"
  }, [_vm._v("Head to your "), _c('a', {
    attrs: {
      "target": "_blank",
      "href": "/settings"
    }
  }, [_vm._v("Account Settings")]), _vm._v(", click \"Add New\" below your email address. Click \"Manage\" next to the newly added address to subscribe to alerts and notifications."), _c('br'), _c('br'), _vm._v("\n        - "), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_c('b', [_vm._v("!")])]), _vm._v(" - Please note that these additional email addresses can not be used for log-in.")])]), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_c('i', {
    staticClass: "dropdown icon"
  }), _vm._v("\n        Notification for "), _c('i', [_vm._v("every")]), _vm._v(" review not just the critical ones, is that available?\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('p', {
    staticClass: "transition hidden"
  }, [_vm._v("Yes! "), _c('a', {
    attrs: {
      "target": "_blank",
      "href": "/settings"
    }
  }, [_vm._v("Account Settings")]), _vm._v(" -> E-mail -> Manage -> tick the \"Notice\" checkbox in the first row, then save your settings on the bottom of the screen. All set!")])]), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_c('i', {
    staticClass: "dropdown icon"
  }), _vm._v("\n        I'm getting a lot of image change alerts lately, but I didn't change anything.\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('p', {
    staticClass: "transition hidden"
  }, [_vm._v("Amazon recently started swapping between product images. This is usually temporary but the change appears on the Amazon API thus triggering an image change alert in SentryKit. We are looking into ways to filter these more effectively. "), _c('br'), _c('br'), _vm._v("\n        - "), _c('b', [_vm._v("Mute frequently occuring image change alerts")]), _vm._v(" right from the alert email: "), _c('br'), _vm._v("Look for the link reading \"*NEW* Don't notify me when the same image change occurs again\"")])]), _vm._v(" "), _c('h5', [_vm._v("Other")]), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_c('i', {
    staticClass: "dropdown icon"
  }), _vm._v("\n        How does the pricing work?\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('p', {
    staticClass: "transition hidden"
  }, [_vm._v("- SentryKit has a Pay-What-You-Use pricing model. Your monthly fee is based on how many ASINs you track. After connecting your Seller Account SentryKit will add all ASINs to your dashboard that have had at least one sale recently. "), _c('br'), _c('br'), _vm._v("\n        - You can change what you track in your "), _c('a', {
    attrs: {
      "target": "_blank",
      "href": "/productsettings"
    }
  }, [_vm._v("Product Settings")]), _vm._v(" at any time - your monthly fee will be recalculated automatically. "), _c('br'), _vm._v("(Also here: setting to add new ASINs to the dashboard automatically. Default is yes.) "), _c('br'), _c('br'), _vm._v("\n        - You can see your current montly fee in your "), _c('a', {
    attrs: {
      "target": "_blank",
      "href": "/settings"
    }
  }, [_vm._v("Account Settings")]), _vm._v(", next to your Stripe details.\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_c('i', {
    staticClass: "dropdown icon"
  }), _vm._v("\n        Can I add more Seller Accounts? (How about EU accounts?)\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('p', {
    staticClass: "transition hidden"
  }, [_vm._v("Yes, as many as you want to! ==> "), _c('a', {
    attrs: {
      "target": "_blank",
      "href": "/settings"
    }
  }, [_vm._v("Account Settings")]), _vm._v(". American and EU/UK marketplaces are all supported.")])]), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_c('i', {
    staticClass: "dropdown icon"
  }), _vm._v("\n        My question is not listed here...\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('p', {
    staticClass: "transition hidden"
  }, [_vm._v("Send us a quick note in the next tab. We read and respond to every message.")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "actions"
  }, [_c('div', {
    staticClass: "ui black cancel button"
  }, [_vm._v("Close")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-38dcd96d!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/HelpModal.vue
// module id = 751
// module chunks = 2